/** URL base de la API. En producción la fija el build (`VITE_API_URL`); en desarrollo, la API local. */
export const API_URL: string = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:8150';
export const VERSION_APP = '2026.10.1';
